import { render, staticRenderFns } from "./DuplicateListItem.vue?vue&type=template&id=7ab23a8c&"
import script from "./DuplicateListItem.vue?vue&type=script&lang=js&"
export * from "./DuplicateListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports